import styled from 'styled-components'

import {tokens} from '@pleo-io/telescope'

import {useAccessRequestsViewedTrackingEffect} from './access-request-tracking'
import {useAccessRequestCount} from './access-requests-bff-hooks'
import {useAccessRequestsEnabled} from './use-is-access-requests-enabled'

const Pill = styled.span`
    margin-left: ${tokens.spacing12};
    padding: 0 ${tokens.spacing10};
    color: ${tokens.shade700};
    font-weight: ${tokens.fontWeightSemibold};
    font-size: ${tokens.fontSmall};
    line-height: 24px;
    background-color: ${tokens.pink300};
    border-radius: ${tokens.arc12};
`

const AccessRequestsCountPill = () => {
    const {accessRequestsEnabled} = useAccessRequestsEnabled()
    const {data, isInitialLoading, isError} = useAccessRequestCount({
        enabled: accessRequestsEnabled ?? false,
    })

    useAccessRequestsViewedTrackingEffect('viewed_notification', data?.data?.count)

    if (isInitialLoading || isError || !data?.data?.count) {
        return null
    }
    return <Pill data-testid="access-request-count-pill">{data?.data?.count}</Pill>
}

export default AccessRequestsCountPill
